/**
 * Pre-compiled fr-FR messages for ScopedSearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { searchLabel: `Rechercher`, selectLabel: `Filtrer par` };
